<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>Chapitre Un</span></h1>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal__And__Left_Indent"><span class="C_FirstWords">LACHLAN</span> McCoughey grommela et tendit la main vers le téléphone qui le réveillait aux environs de trois heures du matin. Seigneur, c’était le risque de faire des affaires partout dans le monde. Les gens oubliaient le décalage horaire.</p>
<p class="P_Normal">— Allô ?</p>
<p class="P_Normal">Il espérait que ce n’était pas une étrange association caritative américaine qui voulait une donation. Sa journée de congé commençait mal.</p>
<p class="P_Normal">— Lachy ? C’est Rick O’Riordan. J’ai des nouvelles.</p>
<p class="P_Normal">— Oh, c’est vrai ? demanda-t-il en se redressant et allumant la lumière.</p>
<p class="P_Normal">Il y a quelques années, il avait engagé un détective privé, Rick, pour retrouver sa sœur, Adélaïde, qui s’était enfuie juste après son vingt-deuxième anniversaire.</p>
<p class="P_Normal">— Lesquelles ?</p>
<p class="P_Normal">— Je… merde, mec, je déteste être l’enfoiré porteur de mauvaises nouvelles.</p>
<p class="P_Normal">Son cuir chevelu picota et la chair de poule se dressa sur ses bras.</p>
<p class="P_Normal">— Dis-moi.</p>
<p class="P_Normal">— Ades se trouvait dans un avion qui s’est écrasé il y a trois semaines aux États-Unis. Elle et son mari.</p>
<p class="P_Normal">Mon Dieu ! Il eut l’impression que Rick venait de le frapper avec un marteau, droit dans le ventre. Comment était-ce possible ? Sa petite sœur, disparue de cette terre ?</p>
<p class="P_Normal">— Je suis vraiment désolé. J’ai vu une coupure de presse. Toutes ces recherches, et je l’avais manquée jusqu’à aujourd’hui.</p>
<p class="P_Normal">— Tu as les détails maintenant ?</p>
<p class="P_Normal">Il ne voulait pas le savoir, mais il le devait. Sa mère… elle méritait de savoir.</p>
<p class="P_Normal">— Oui. Lachy… il y a beaucoup.</p>
<p class="P_Normal">Il se frotta les yeux de sa main libre.</p>
<p class="P_Normal">— À quel point ? Tu as dit qu’elle était mariée.</p>
<p class="P_Normal">Il ne l’aurait pas deviné.</p>
<p class="P_Normal">— Oui. À un cavalier de taureaux du Texas. Ils… ils se sont mariés il y a deux ans et demi. Ils avaient… oh merde ! Ils avaient un bébé. Une petite nana. Âgée de trois mois et demi.</p>
<p class="P_Normal">Son cœur s’arrêta l’espace d’un instant. S’arrêta vraiment.</p>
<p class="P_Normal">— Elle se trouvait dans l’avion ?</p>
<p class="P_Normal">— Non. Non, elle était avec la famille de son père.</p>
<p class="P_Normal">— Dieu merci.</p>
<p class="P_Normal">Ses mains tremblèrent, son corps entier commença à trembler.</p>
<p class="P_Normal">— Où est-elle maintenant ?</p>
<p class="P_Normal">— Elle vit avec les Sheffield. C’est le nom de la famille.</p>
<p class="P_Normal">— Attends. Elle était mariée à Landon Sheffield ?</p>
<p class="P_Normal">Sheffield, ce petit enfoiré ! Bon sang, qu’avait vu Ades en lui ? Ce connard avait été invité dans sa maison. Un serpent sous le toit sacré.</p>
<p class="P_Normal">— Oui. Tu le connais ?</p>
<p class="P_Normal">— Un cowboy ricain. Il était dans le coin pour une grande tournée. Ils ont fait un tournage promotionnel ici.</p>
<p class="P_Normal">Il allait péter les plombs.</p>
<p class="P_Normal">— Il avait un frère jumeau. Euh…</p>
<p class="P_Normal">Il entendit un bruissement de papiers.</p>
<p class="P_Normal">— Holden. Il est nommé sur le testament comme tuteur.</p>
<p class="P_Normal">— Pas les grands-parents ?</p>
<p class="P_Normal">— Non, mec.</p>
<p class="P_Normal">— Merde.</p>
<p class="P_Normal">D’accord, ça n’allait pas marcher. Il n’avait jamais rencontré le frère, mais les Sheffield étaient des gens du rodéo. Une petite fille avait besoin d’un foyer stable. Pas d’une vie de nomade, où rien ne restait à la même place plus d’une semaine. Elle avait besoin d’une maison. Sa mère était morte et il ne l’avait même pas su.</p>
<p class="P_Normal">— Comment puis-je les trouver ? demanda Lachlan.</p>
<p class="P_Normal">— J’ai les numéros de téléphone et une adresse. Je t’enverrai le tout. Ça ne me paraissait pas juste de le savoir et d’attendre demain matin pour t’appeler.</p>
<p class="P_Normal">— Je comprends. Il faut que je trouve un vol. Merci de ne pas avoir abandonné.</p>
<p class="P_Normal">— N’importe quoi, n’importe quand. Tu le sais.</p>
<p class="P_Normal">Oui. Oui, il le savait. Rick le soutenait depuis qu’il avait repris l’entreprise familiale, à l’âge de dix-huit ans. L’homme était réfléchi, solide et attentionné. Ce qui le rendait bon dans son travail.</p>
<p class="P_Normal">Il raccrocha avec Rick après s’être arrangé pour obtenir les informations par e-mail, puis il envisagea de réveiller son assistante, Gina.</p>
<p class="P_Normal">Ah, il la payait suffisamment ; elle pouvait bien organiser son voyage dès que possible. Il cliqua sur son nom à l’écran, sachant combien elle aimait les défis.</p>
<p class="P_Normal">Elle répondit à la deuxième sonnerie.</p>
<p class="P_Normal">— Pa… Patron ? Qu’est-ce qui ne va pas, patron ?</p>
<p class="P_Normal">— Ades. Elle est morte. Je dois me rendre aux États-Unis. Maintenant.</p>
<p class="P_Normal">La voix de Gina s’aiguisa, pleinement réveillée.</p>
<p class="P_Normal">— Oh, patron. Je suis désolée. Où ? Y a-t-il un enterrement à planifier ? Un hôtel ? J’ai besoin de détails.</p>
<p class="P_Normal">— Je vous envoie les infos. Accident d’avion. Texas. Il y a trois semaines. Immédiatement, Gina.</p>
<p class="P_Normal">— Oui, monsieur. Je vous envoie les réservations. Dois-je appeler Leeyah afin qu’elle prépare vos valises ?</p>
<p class="P_Normal">— Oui. Oui. Je vais… j’attends votre appel.</p>
<p class="P_Normal">Il allait prendre une bière, s’asseoir et penser à sa petite sœur, combien ils avaient passé leur enfance dans les pattes l’un de l’autre.</p>
<p class="P_Normal">Son visage se tordit en une grimace, la douleur le frappant tandis qu’il raccrochait. Ades. Disparue. Pour toujours. Ça ne pouvait pas être possible. Elle était…</p>
<p class="P_Normal">Qu’allait-il dire à sa mère ? Elle allait s’effondrer, aucun doute là-dessus. Ades avait toujours été sa préférée, ce qui n’avait même pas fait de lui un connard amer. Ades était sa fille.</p>
<p class="P_Normal">— Merde, frangine. À quoi pensais-tu, bordel ? Tu… tu t’es enfuie !</p>
<p class="P_Normal">Il se tenait là, comme un fou, hurlant à la lune.</p>
<p class="P_Normal">D’accord, non. Il devait se ressaisir, transférer tous les e-mails de Rick à Gina.</p>
<p class="P_Normal">Il pourrait s’écrouler plus tard.</p>
<p class="P_Normal">Beaucoup plus tard.</p>
<p class="P_Normal">Genre, après avoir ramené sa nièce à ses grands-parents, là où était sa place.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0005.vue?11aa5698